/*-----------------------------------------------------------------
- Blog Page
-----------------------------------------------------------------*/

export default {
    title: 'Blog',

    read_text: '{0} min Read',

    alt: {
        hero_bg: 'curly shape',
        post   : 'blog post',
        avatar : 'user avatar',
        arrow  : 'arrow',
        icon   : 'icon',

    },
    button: {
        see_more: 'Load More',
    },
    categories_title      : 'Categories',
    search                : 'Search in Blog ',
    no_posts              : 'There is nothing to show',
    page_contents_title   : 'Table of Content',
    share_in_socials      : 'Like this article? Spread the word.',
    tags                  : 'TAGS: ',
    author                : 'Author',
    more_articles         : 'More articles from {0}',
    similar_articles_title: 'You might also like',
    category_list         : 'Category List',
    latest_articles       : 'Latest Articles',
    popular_articles      : 'Popular Articles',

};
